import {RepoIcon} from '@primer/octicons-react'
import {Blankslate} from '@primer/react/experimental'

export interface UserInfo {
  directOrTeamMember: boolean
  admin: boolean
  canCreateRepository: boolean
}

interface Props {
  currentPage: number
  pageCount: number
  filtered?: boolean
  orgName?: string
  userInfo?: UserInfo
}

export function getNoRepoMessage({currentPage, filtered, pageCount, userInfo}: Omit<Props, 'orgName'>): {
  heading: string
  description?: string
} {
  const {directOrTeamMember, admin} = userInfo || {}
  if (pageCount > 0 && currentPage > pageCount) {
    return {heading: 'No more repositories.', description: 'Visit a lower page.'}
  } else if (filtered) {
    return {heading: 'No repositories matched your search.', description: 'Try a different search query.'}
  } else if (admin) {
    return {heading: 'This organization has no repositories.'}
  } else if (directOrTeamMember) {
    return {heading: "Your teams don't have access to any repositories."}
  } else {
    return {heading: 'This organization has no public repositories.'}
  }
}

export function NoReposMessage({currentPage, filtered, pageCount, userInfo}: Props) {
  const message = getNoRepoMessage({currentPage, filtered, pageCount, userInfo})
  return <NoReposBlankslate message={message} />
}

export function NoReposBlankslate({message}: {message: {heading: string; description?: string}}) {
  return (
    <Blankslate>
      <Blankslate.Visual>
        <RepoIcon size={24} />
      </Blankslate.Visual>

      <Blankslate.Heading>{message.heading}</Blankslate.Heading>
      {message.description && <Blankslate.Description>{message.description}</Blankslate.Description>}
    </Blankslate>
  )
}

try{ NoReposMessage.displayName ||= 'NoReposMessage' } catch {}
try{ NoReposBlankslate.displayName ||= 'NoReposBlankslate' } catch {}